import React from "react";
import { Table } from "reactstrap";
import { formatCurrency, formatInteger } from "./dashboardFormat";

// Cupons usados em vendas pagas.
//
// Desconto e receita lado a lado de propósito: um cupom que concede muito e traz
// pouco é cortesia com outro nome, e é essa comparação que mostra isso. Os dois
// números saem de `promo_off` e `amount` da própria transação — não há
// reprecificação aqui.

export default function CouponsTable({ coupons = [] }) {
  if (coupons.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhum cupom usado em vendas pagas.
      </div>
    );
  }

  const totalDiscount = coupons.reduce((total, row) => total + row.discount, 0);

  return (
    <div className="table-responsive">
      <Table className="table-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th style={{ fontWeight: 500, color: "#74788d" }}>Cupom</th>
            <th style={{ fontWeight: 500, color: "#74788d" }}>Usos</th>
            {/* Dinheiro à direita, como na tela de Vendas Consolidadas: desconto
                e receita ficam em colunas que se comparam de cima a baixo. */}
            <th className="text-end" style={{ fontWeight: 500, color: "#74788d" }}>
              Desconto concedido
            </th>
            <th className="text-end" style={{ fontWeight: 500, color: "#74788d" }}>
              Receita gerada
            </th>
          </tr>
        </thead>
        <tbody>
          {coupons.map((coupon) => (
            <tr key={coupon.code}>
              <td style={{ fontWeight: 600, color: "#1f2937" }}>{coupon.code}</td>
              <td>{formatInteger(coupon.uses)}</td>
              <td className="text-end text-nowrap" style={{ color: "#b42318", fontVariantNumeric: "tabular-nums" }}>
                − {formatCurrency(coupon.discount)}
              </td>
              <td
                className="text-end text-nowrap"
                style={{ fontWeight: 600, color: "#1f2937", fontVariantNumeric: "tabular-nums" }}
              >
                {formatCurrency(coupon.amount)}
              </td>
            </tr>
          ))}
          <tr>
            <td style={{ fontWeight: 600, color: "#495057" }}>Total</td>
            <td />
            <td
              className="text-end text-nowrap"
              style={{ fontWeight: 600, color: "#b42318", fontVariantNumeric: "tabular-nums" }}
            >
              − {formatCurrency(totalDiscount)}
            </td>
            <td />
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
